<template>
    <el-dialog :visible.sync="dialogVisible" title="选择商品" style="margin-top: 8vh;" width="1000px" :append-to-body="true" :modal="false">
        <el-form :model="searchForm" @submit.native.prevent size="mini" inline>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">商品名称</span>
                            <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                </el-col>

                <!-- 修改后的商品编码搜索部分 -->
                <el-col :span="8">
                    <el-form-item>
                        <div class="input-with-select">
                            <div style="display: flex; align-items: center; width: 210px;">
                                <el-select v-model="codeSearchType" placeholder="选择类型" clearable style="width: 120px;"
                                    class="category-select">
                                    <el-option label="商品编码" value="goodsNo"></el-option>
                                    <el-option label="商品外部编码" value="outGoodsNo"></el-option>
                                </el-select>
                                <el-input v-model="codeSearchValue" placeholder="请输入" clearable style="width: 120px;"
                                    class="value-select">
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                </el-col>

                <el-col :span="8" class="input-with-select">
                    <el-button type="primary" @click="searchGoods" size="mini">查询</el-button>
                    <el-button @click="resetSearch" size="mini">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <!-- 其余部分保持不变 -->
        <div v-loading="loading">
            <lb-table v-horizontal-scroll='"always"' border :column="columns" align="center" :data="goodsList"
                pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
                @size-change="handleSizeChange" @p-current-change="handleCurrentChange" @refresh="fetchData"
                :orderStatistics="page.totalNum" is-goods-selector statisticText="当前列表统计总商品数"
                @selection-change="handleTableSelectionChange" ref="tableRef">
            </lb-table>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmSelection" size="mini">提交</el-button>
            <el-button @click="dialogVisible = false" size="mini">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import LbTable from '@/pages/purchase/components/lb-table/lb-table'

export default {
    components: {
        LbTable,
    },
    name: 'GoodsSelector',
    data() {
        return {
            dialogVisible: false,
            searchForm: {
                name: '',
                // 不再直接使用code字段
                categoryValue: ''
            },
            // 新增代码搜索类型和值
            codeSearchType: 'goodsNo', // 默认选择商品编码
            codeSearchValue: '',
            goodsList: [],
            selectedGoods: [],
            loading: false,
            page: {
                currentPage: 1,
                pageSize: 10,
                totalNum: 0
            },
            queryForm: {
                categoryType: ''
            },
            columns: [
                {
                    type: 'selection',
                    width: '55',
                    slot: true
                },
                {
                    label: '序号',
                    prop: 'index',
                    width: '50',
                    render: (h, scope) => {
                        const index = (this.page.currentPage - 1) * this.page.pageSize + scope.$index + 1;
                        return h('div', index);
                    }
                },
                {
                    label: '图片',
                    prop: 'mainImage',
                    width: '100',
                    render: (h, scope) => {
                        if (scope.row.mainImage) {
                            return h('img', {
                                attrs: {
                                    src: scope.row.mainImage,
                                    width: '50px',
                                    height: '50px',
                                    style: 'object-fit: cover;'
                                }
                            });
                        } else {
                            return h('div', '-');
                        }
                    }
                },
                {
                    label: '商品编码',
                    prop: 'goodsNo',
                    width: '120'
                },
                {
                    label: '商品名称',
                    prop: 'name',
                    width: '120',
                    render: (h, scope) => {
                        return h('div', scope.row.name || '-');
                    }
                },
                {
                    label: '商品外部编码',
                    prop: 'outGoodsNo',
                    width: '120'
                },
                {
                    label: '实际总库存',
                    prop: 'stock',
                    width: '80'
                },
                {
                    label: '拣货单位',
                    prop: 'unit',
                    width: '80'
                },
                {
                    label: '重量',
                    prop: 'category',
                    width: '120'
                },
                {
                    label: '体积',
                    prop: 'brand',
                    width: '120'
                },
            ],
        };
    },
    methods: {
        show() {
            this.dialogVisible = true;
            // 清空选中状态，但不重置 selectedGoods
            this.goodsList.forEach(item => {
                item.selected = false;
            });
            this.searchGoods();
        },
        handleSelectionChange(row) {
            // 使用 Vue.set 或 $set 确保响应式更新
            if (row.selected) {
                if (!this.selectedGoods.some(item => item.id === row.id)) {
                    // 使用 $set 或 push 到新数组确保响应式
                    this.selectedGoods = [...this.selectedGoods, row];
                }
            } else {
                const index = this.selectedGoods.findIndex(item => item.id === row.id);
                if (index !== -1) {
                    // 使用 splice 确保响应式
                    this.selectedGoods.splice(index, 1);
                }
            }
            console.log('当前选中商品:', this.selectedGoods); // 调试日志
        },
        confirmSelection() {
            console.log('确认选择时的选中商品:', this.selectedGoods); // 调试日志

            // 确保使用响应式数据
            const selected = [...this.selectedGoods];
            if (selected.length === 0) {
                this.$message.warning('请至少选择一个商品');
                return;
            }

            this.$emit('selected', selected);
            this.dialogVisible = false;

            // 不清空 selectedGoods，只重置选中状态
            this.goodsList.forEach(item => {
                item.selected = false;
            });
        },
        // ✅ 接收表格选中项变化
        handleTableSelectionChange(selection) {
            console.log('✅ 表格选中项变化:', selection);
            this.selectedGoods = selection; // 直接赋值
        },

        // ✅ 提交时获取当前选中行
        confirmSelection() {
            // 从 table 中获取当前选中行
            const selected = this.$refs.tableRef.$refs.elTable.selection;
            console.log('确认选择时的选中商品:', selected);

            if (!selected || selected.length === 0) {
                this.$message.warning('请至少选择一个商品');
                return;
            }

            this.$emit('selected', selected);
            this.dialogVisible = false;

            // 可选：关闭后清除选中状态
            this.$nextTick(() => {
                this.$refs.tableRef.$refs.elTable.clearSelection();
            });
        },

        // 查询时同步已选状态（可选增强体验）
        searchGoods() {
            this.loading = true;
            const params = {
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize,
                name: this.searchForm.name,
                [this.codeSearchType]: this.codeSearchValue,
                categoryType: this.queryForm.categoryType,
                categoryValue: this.searchForm.categoryValue
            }

            this.$api.goodsPageList(params).then(res => {
                if (res.code === 0) {
                    this.goodsList = res.data.list;
                    this.page.totalNum = res.data.totalNum;

                    // ✅ 关键：等数据渲染后，手动设置选中状态
                    this.$nextTick(() => {
                        const table = this.$refs.tableRef.$refs.elTable;
                        this.goodsList.forEach(row => {
                            const isSelected = this.selectedGoods.some(sel => sel.id === row.id);
                            if (isSelected) {
                                table.toggleRowSelection(row, true);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        // 添加重置选中状态的方法
        resetSelection() {
        this.selectedGoods = [];
        this.goodsList.forEach(item => {
            item.selected = false;
        });
    },
    resetSearch() {
        this.searchForm.name = '';
        this.searchForm.categoryValue = '';
        this.codeSearchType = 'goodsNo'; // 重置为默认值
        this.codeSearchValue = '';
        this.queryForm.categoryType = '';
        this.page.currentPage = 1;
        this.searchGoods();
    },
    handleCategoryTypeChange(value) {
        // 分类类型改变的处理逻辑
        console.log('分类类型改变:', value);
    },
    handleSizeChange(size) {
        this.page.pageSize = size;
        this.searchGoods();
    },
    handleCurrentChange(page) {
        this.page.currentPage = page;
        this.searchGoods();
    },
    fetchData() {
        this.searchGoods();
    }
}
};
</script>

<style lang="scss" scoped>
/* 样式保持不变 */
.dialog-footer {
    text-align: right;
    padding: 10px 0;
}

.form-item-inline {
    margin-bottom: 0;
}

/* 下拉框组样式 */
.input-with-select {
    margin-top: 20px;
    display: flex;
    align-items: center;

    /deep/ {
        .el-input__inner {
            font-weight: 400;
            font-size: 12px;
            width: 120px;
            border-radius: 0;
            height: 24px;
            line-height: 24px;

        }
    }

    .prepend-text {
        width: 90px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family: Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
        border-radius: 4px 0 0 4px;
    }

    .category-select {
        ::v-deep .el-input__inner {
            font-weight: 400;
            font-size: 12px;
            width: 160px;
            border-radius: 0;
            background-color: #F5F7FA;
            height: 24px;
            line-height: 24px;
            padding: 0 0 0 6px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;

        }
    }

    .value-select {
        ::v-deep .el-input__inner {
            border-radius: 0 4px 4px 0;

            height: 24px;
            line-height: 24px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;
        }
    }
}

.form-buttons {
    display: flex;
    align-items: center;
    height: 32px;
}
</style>